import { Pipe, PipeTransform } from '@angular/core';
import { StringTransformHelper } from './string-transform.helper';

@Pipe({
  name: 'titleCase'
})
export class TitleCasePipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (!value) {
      return;
    }
    return StringTransformHelper.toTitleCase(value);
  }

}



// WEBPACK FOOTER //
// ./ts/app/shared/title-case.pipe.ts